import { render } from "./SystemUserForm.vue?vue&type=template&id=c4288ff0&scoped=true&ts=true"
import script from "./SystemUserForm.vue?vue&type=script&lang=ts"
export * from "./SystemUserForm.vue?vue&type=script&lang=ts"

import "./SystemUserForm.vue?vue&type=style&index=0&id=c4288ff0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4288ff0"]])

export default __exports__